import React from 'react';
import {
  GeckoModal,
  GeckoModalService,
  GECKO_CONSTS,
  GeckoToastService,
} from '../../../ui';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';

const CloseConversationModal = ({ conversation, setActionTimestamp }) => {
  return (
    <GeckoModal
      name="Close conversation"
      children={<p>Are you sure you want to close this conversation?</p>}
      btns={[
        {
          name: 'Cancel',
          secondary: true,
          icon: 'far fa-times',
          handler: () => {
            return new GeckoModalService().close();
          },
        },
        {
          type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
          name: 'Confirm close',
          icon: 'far fa-check-double',
          handler: () => {
            GeckoRequest.post(`/conversation/close`, {
              conversation_id: conversation.id,
            })
              .then(() => {
                new GeckoModalService().close();
                new GeckoToastService().success('Conversation closed');
                setActionTimestamp(Date.now());
              })
              .catch(renderError);
          },
        },
      ]}
    />
  );
};

export default CloseConversationModal;
